export type RoundFeedbackKind = "match" | "opponent" | "error" | "notice";

export type RoundFeedbackEvent = {
  kind: RoundFeedbackKind;
  /** Only errors and connection notices need visible text during a round. */
  label?: string;
  announcement: string;
  playerId?: string;
};

export type RoundFeedbackState = RoundFeedbackEvent & { id: number };

/** Latest event wins. Feedback never queues turns, disables cards or delays play. */
export class RoundFeedback {
  private timer: ReturnType<typeof setTimeout> | undefined;
  private serial = 0;
  private state: RoundFeedbackState | null = null;

  constructor(private readonly onChange: (state: RoundFeedbackState | null) => void) {}

  get current(): RoundFeedbackState | null {
    return this.state;
  }

  show(event: RoundFeedbackEvent): void {
    clearTimeout(this.timer);
    this.state = { ...event, id: ++this.serial };
    this.onChange(this.state);
    this.timer = setTimeout(() => this.clear(), event.kind === "error" || event.kind === "notice" ? 1_600 : 650);
  }

  clear(): void {
    clearTimeout(this.timer);
    this.timer = undefined;
    if (!this.state) return;
    this.state = null;
    this.onChange(null);
  }
}
